export default __webpack_public_path__ + "static/media/406.307df763.png";